<template>
  <div class="container">
    <div>
      <p>ประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล</p>
      <p>PERSONAL DATA PROTECTION NOTICE</p>
      <p style="padding-top:20px">เรียน ผู้ใช้งานและผู้เยี่ยมชมที่เคารพ</p>
      <p>Dear Valued Users and Guests,</p>
      <p style="padding-top:20px">
        ประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลนี้ (“ประกาศ”)
        แจ้งถึงผู้ใช้งานและผู้เยี่ยมชมที่เคารพทุกท่านของ บริษัท คาร์ซัม
        (ประเทศไทย) จำกัดและบริษัทในเครือ (“คาร์ซัม”)
        ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“PDPA”).
      </p>
      <p>
        This Personal Data Protection Notice (“Notice”) is issued to all valued
        users and guests of Carsome (Thailand) Co., Ltd. and its affiliate
        (“Carsome”) pursuant to the Personal Data Protection Act B.E. 2562
        (2019) (“PDPA”).
      </p>
      <ul style="padding-top:20px">
        <li>
          <p>
            1.&nbsp;&nbsp;&nbsp;ในระหว่างที่ท่านติดต่อกับเรา
            เราจะดำเนินการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์
            ซึ่งรวมถึงเพื่อสื่อสารกับท่าน จัดหาผลิตภัณฑ์และ/หรือให้บริการกับท่าน
            ตอบข้อซักถามของท่าน ให้ข้อมูลและอัปเดตเกี่ยวกับผลิตภัณฑ์ บริการ
            และโปรโมชั่นของเราที่นำเสนอโดยคาร์ซัม
            และวัตถุประสงค์อื่นที่จำเป็นในการดำเนินงานและดำรงธุรกิจของเราตามที่กำหนดไว้ในนโยบายการคุ้มครองข้อมูลส่วนบุคคลของเรา
            (ซึ่งจะเรียกรวมกันว่า “วัตถุประสงค์”)
          </p>
        </li>
        <li>
          <p>
            1.&nbsp;&nbsp;&nbsp;During your course of dealing with us, we will
            collect and process your personal data for purposes, including, to
            communicate with you, provide products and/or services to you,
            respond to your enquiries, provide information and updates on our
            products, services and promotions offered by Carsome and other
            purposes required to operate and maintain our business as set out in
            our Personal Data Protection Policy (collectively referred to as
            “Purposes”).
          </p>
        </li>
        <li>
          <p>
            2.&nbsp;&nbsp;&nbsp;เรายึดมั่นที่จะตรวจสอบให้แน่ใจว่าข้อมูลส่วนบุคคลของท่านได้รับการจัดเก็บอย่างปลอดภัย
            ท่านมีสิทธิ์ที่จะร้องขอการเข้าถึงขอรับสำเนา
            ขอแก้ไขปรับปรุงข้อมูลให้เป็นปัจจุบันหรือแก้ไขข้อมูลส่วนบุคคลของท่านที่เราเก็บไว้
            ท่านมีสิทธิที่จะขอให้เราจำกัดการประมวลผลและการใช้ข้อมูลส่วนบุคคลของท่านได้ตลอดเวลา
            โดยส่งคำขอของท่านเป็นลายลักษณ์อักษรไปยังเจ้าหน้าที่ที่กำกับดูแลการปฏิบัติงานของเราที่
            &lt;<a href="mailto:info@carsome.co.th" target="_blank"
              >info@carsome.co.th</a
            >&gt;
          </p>
        </li>
        <li>
          <p>
            2.&nbsp;&nbsp;&nbsp;We are committed to ensuring that your personal
            data is stored securely. You have the right to request for access
            to, request for a copy of, request to update or correct your
            personal data held by us. You have the right at any time to request
            us to limit the processing and use of your personal data. Your
            written request should be addressed to our Compliance Officer at
            &lt;<a href="mailto:info@carsome.co.th" target="_blank"
              >info@carsome.co.th</a
            >&gt;.
          </p>
        </li>
        <li>
          <p>
            3.&nbsp;&nbsp;&nbsp;ประกาศนี้จัดทำขึ้นเป็นภาษาอังกฤษและภาษาไทยและหากมีความหมายขัดแย้งกันระหว่างภาษาอังกฤษและภาษาไทยให้ภาษาไทยมีผลเหนือกว่า
            โดยการเข้าถึงเว็บไซต์นี้ และ/หรือ การส่งข้อมูลส่วนบุคคลของท่านให้เรา
            ถือว่าท่านได้อ่าน ทำความเข้าใจและยอมรับข้อกำหนดของประกาศนี้
            และยินยอมให้มีการรวบรวมและประมวลผลข้อมูลส่วนบุคคลของท่านโดยคาร์ซัมตามประกาศนี้และนโยบายการคุ้มครองข้อมูลส่วนบุคคลของเรา
          </p>
        </li>
        <li>
          <p>
            3.&nbsp;&nbsp;&nbsp;This Notice is provided in English and Thai
            languages and should there be any conflict in meaning between the
            English and Thai language version, the Thai language version shall
            prevail. By accessing this website and/or submitting your personal
            data to us, you are deemed to have read, understood and accepted the
            terms of this Notice, and consent to the collection and processing
            of your personal data by Carsome as per this Notice and our Personal
            Data Protection Policy.
          </p>
        </li>
        <li>
          <p>
            4.&nbsp;&nbsp;&nbsp;เราขอสงวนสิทธิ์ในการปรับปรุงให้เป็นปัจจุบันและแก้ไขประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลและนโยบายการคุ้มครองข้อมูลส่วนบุคคลของเราเป็นครั้งคราว
            เราจะแจ้งให้ท่านทราบหากมีการแก้ไขเพิ่มเติมใด ๆ
            ผ่านการประกาศบนเว็บไซต์ของเราหรือวิธีการอื่นที่เหมาะสม
          </p>
        </li>
        <li>
          <p>
            4.&nbsp;&nbsp;&nbsp;We reserve the right to update and amend this
            Personal Data Protection Notice and our Personal Data Protection
            Policy from time to time. We will notify you of any amendments via
            announcements on our website or other appropriate means.
          </p>
        </li>
      </ul>
      <p>วันที่: 15 มิถุนายน 2564</p>
      <p>Dated: June 15, 2021</p>
      <p></p>
      <h2>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</h2>
      <h2>1. บทนำ</h2>
      <ul>
        <li>
          <p>
            1.1&nbsp;นโยบายนี้ใช้กับข้อมูลส่วนบุคคลที่เกี่ยวกับบุคคล (รวมไปถึง
            แต่ไม่จำกัดแค่เพียง ลูกค้า ผู้ขาย ผู้จัดจำหน่าย ผู้ผลิต ผู้ให้บริการ
            กิจการร่วมค้า/พันธมิตรทางธุรกิจ ผู้สมัครงาน พนักงาน) ที่เราเก็บไว้
            โดยเราจะประมวลผลข้อมูลส่วนบุคคลของท่านตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ. 2562 ข้อบังคับ แนวทาง คำสั่ง
            ที่บังคับใช้ภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
            และการแก้ไขตามกฎหมายหรือการออกกฎหมายใหม่ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ. 2562 เป็นครั้งคราว (ซึ่งจะเรียกรวมกันว่า “PDPA”)
            รวมทั้งนโยบายนี้
          </p>
        </li>
        <li>
          <p>
            1.2&nbsp;โดยการให้ข้อมูลส่วนบุคคลของท่านแก่เรา และ/หรือ ดำเนินการต่อ
            เพื่อเข้าถึงและใช้งานเว็บไซต์ของเรา (“ไซต์”)
            แสดงว่าท่านได้อ่านและเข้าใจนโยบายนี้และตกลงให้เราประมวลผลข้อมูลส่วนบุคคลของท่านตามที่กำหนดไว้ในนโยบายนี้
          </p>
        </li>
        <li>
          <p>
            1.3&nbsp;เราขอสงวนสิทธิ์ในการแก้ไข ปรับปรุงให้เป็นปัจจุบัน และ/หรือ
            แก้ไขนโยบายนี้เป็นครั้งคราว
            โดยเราจะแจ้งให้ท่านทราบเกี่ยวกับการแก้ไขใด ๆ
            ผ่านการประกาศบนไซต์หรือวิธีการอื่นที่เหมาะสม
            กรุณาตรวจสอบไซต์เป็นครั้งคราวเพื่อดูการแก้ไขเพิ่มเติมนโยบายนี้
          </p>
        </li>
        <li>
          <p>
            1.4&nbsp;ในกรณีที่ท่านไม่เห็นด้วยกับนโยบายนี้หรือการแก้ไขใด ๆ
            ต่อนโยบายนี้
            เราอาจไม่สามารถให้บริการทั้งหมดแก่ท่านได้และอาจต้องบอกเลิกสัญญาต่าง
            ๆ ที่เกี่ยวข้องที่ท่านมีกับเรา และ/หรือ หยุดการเข้าถึงหรือใช้งานไซต์
          </p>
        </li>
      </ul>
      <h2>2. การเก็บรวบรวมข้อมูลส่วนบุคคล</h2>
      <ul>
        <li>
          <p>
            2.1&nbsp;“ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลใด ๆ ที่อยู่ในความครอบครอง
            หรือการควบคุมของเรา
            ซึ่งเกี่ยวข้องโดยตรงหรือโดยอ้อมกับบุคคลในขอบเขตที่สามารถระบุตัวบุคคลหรือใช้ระบุตัวตนได้จากข้อมูลนั้นและข้อมูลอื่น
            ๆ ที่อยู่ในความครอบครองของเรา เช่น ชื่อ ที่อยู่ หมายเลขโทรศัพท์
            หมายเลขประจำตัวประชาชน/หมายเลขหนังสือเดินทาง วันเกิด รูปถ่าย
            ที่อยู่อีเมล ข้อมูลครอบครัว และอื่น ๆ
            รวมถึงข้อมูลส่วนบุคคลทอ่อนไหวตามที่กำหนดไว้ใน PDPA
            รวมไปถึงแต่ไม่จำกัดแค่เพียงข้อมูลที่เกี่ยวข้องกับสุขภาพร่างกายหรือสุขภาพจิต
            หรือสถานะเจ้าของข้อมูลส่วนบุคคลและความเชื่อทางศาสนา
          </p>
        </li>
        <li>
          <p>
            2.2&nbsp;ประเภทของข้อมูลส่วนบุคคลที่เก็บรวบรวมขึ้นอยู่กับวัตถุประสงค์ของการเก็บรวบรวม
            โดยเราอาจประมวลผลข้อมูลส่วนบุคคลของท่านโดยใช้วิธีการเก็บรวบรวม
            บันทึก ยึดถือ เก็บรักษา ใช้งาน และ/หรือ เปิดเผยข้อมูล
          </p>
        </li>
        <li>
          <p>
            2.3&nbsp;ข้อมูลส่วนบุคคลของท่านอาจถูกเก็บรวบรวมจากท่านในระหว่างที่ติดต่อกับเราไม่ว่าโดยวิธีหรือลักษณะใด
            รวมไปถึงธุรกรรม และ/หรือ การสื่อสารใด ๆ ที่เกิดจาก/กับเรา นอกจากนี้
            เรายังอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งอื่น ๆ
            รวมไปถึงแต่ไม่จำกัดแค่เพียงกิจกรรม สัมมนา งานโรดโชว์
            การสำรวจความพึงพอใจของลูกค้าใด ๆ ที่จัดขึ้น และ/ หรือ สนับสนุนโดยเรา
            ตลอดจนจากแหล่งข้อมูลที่เป็นสาธารณะ
          </p>
        </li>
        <li>
          <p>
            2.4&nbsp;นอกจากนี้ เรายังอาจได้รับ
            เก็บรักษาและประมวลผลข้อมูลส่วนบุคคลของท่านซึ่งจัดหาหรือจัดทำขึ้นโดยบุคคลที่สาม
            หน่วยงานอ้างอิงด้านเครดิต หน่วยงานที่ควบคุมและบังคับใช้กฎหมาย
            โดยมีเหตุผลรวมไปถึงการส่งมอบผลิตภัณฑ์ และ/หรือ บริการของเรา
            การปฏิบัติตามเงื่อนไขของสัญญา และ/หรือ
            เพื่อปฏิบัติตามภาระหน้าที่ตามกฎหมายของเรา
          </p>
        </li>
        <li>
          <p>
            2.5&nbsp;ข้อมูลส่วนบุคคลที่ท่านจัดเตรียม/จัดหาให้กับเรา
            หรือที่เราเก็บรวบรวมจากท่าน หรือผ่านทางแหล่งอื่น ๆ
            ที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ในขณะที่ถูกค้นหาหรือเก็บรวบรวม
            อาจถูกประมวลผลเพื่อวัตถุประสงค์ต่อไปนี้ (ซึ่งเรียกรวมกันว่า
            “วัตถุประสงค์”):
          </p>
          <ul>
            <li><p>(a) เพื่อสื่อสารกับท่าน;</p></li>
            <li><p>(b) เพื่อรักษาและปรับปรุงความสัมพันธ์กับลูกค้า;</p></li>
            <li>
              <p>
                (c) เพื่อประเมิน ดำเนินการและจัดหาผลิตภัณฑ์ บริการ และ/หรือ
                สิ่งอำนวยความสะดวกให้กับท่าน;
              </p>
            </li>
            <li>
              <p>
                (d) เพื่อจัดการและประมวลผลการชำระเงินใด ๆ
                ที่เกี่ยวข้องกับผลิตภัณฑ์ บริการ และ/หรือ
                สิ่งอำนวยความสะดวกตามที่ท่านร้องขอ;
              </p>
            </li>
            <li><p>(e) เพื่อระบุตัวตนและประวัติของท่าน;</p></li>
            <li>
              <p>
                (f) เพื่อตอบข้อซักถามหรือข้อร้องเรียนของท่านและแก้ไขปัญหา
                และ/หรือ ข้อพิพาทใด ๆ ที่อาจเกิดขึ้นจากการติดต่อกับเรา;
              </p>
            </li>
            <li>
              <p>
                (g) เพื่อให้ข้อมูล และ/หรือ อัปเดตเกี่ยวกับผลิตภัณฑ์
                บริการของเรา โปรโมชั่นที่จะเกิดขึ้นที่เรานำเสนอ และ/หรือ
                กิจกรรมที่จัดโดยเราและบุคคลที่สามที่เราเลือกไว้
                ซึ่งอาจเป็นที่สนใจของท่าน เป็นครั้งคราว;
              </p>
            </li>
            <li>
              <p>
                (h) เพื่อวัตถุประสงค์ทางการตลาดโดยตรงผ่าน ข้อความ (SMS) โทรศัพท์
                อีเมล โทรสาร จดหมาย โซเชียลมีเดีย และ/หรือ ช่องทางการสื่อสารอื่น
                ๆ ที่เหมาะสม;
              </p>
            </li>
            <li>
              <p>
                (i) เพื่ออำนวยความสะดวกในการมีส่วนร่วมของท่าน และการจัดกิจกรรมใด
                ๆ รวมไปถึงการแข่งขัน โปรโมชั่น หรือแคมเปญ;
              </p>
            </li>
            <li>
              <p>(j) เพื่อมอบคะแนนหรือรางวัล ในโปรแกรมความภักดีของลูกค้า;</p>
            </li>
            <li>
              <p>(k) เพื่อรักษาและปรับปรุงการเก็บบันทึกภายในให้เป็นปัจจุบัน;</p>
            </li>
            <li><p>(l) เพื่อวัตถุประสงค์ในการจัดการภายใน;</p></li>
            <li>
              <p>(m) เพื่อส่งข้อความทักทายตามช่วงเทศกาลให้ท่านเป็นครั้งคราว;</p>
            </li>
            <li>
              <p>
                (n) เพื่อส่งคำเชิญให้ท่านเข้าร่วมกิจกรรม
                โปรโมชั่นและงานเปิดตัวผลิตภัณฑ์ของเรา;
              </p>
            </li>
            <li>
              <p>
                (o) เพื่อติดตาม ตรวจสอบและปรับปรุงกิจกรรม โปรโมชั่น ผลิตภัณฑ์
                และ/หรือ บริการของเรา;
              </p>
            </li>
            <li>
              <p>
                (p)
                เพื่อดำเนินการตรวจสอบการอ้างอิงเครดิตและสร้างความน่าเชื่อถือทางเครดิตของท่านในกรณีจำเป็น
                ในการจัดหาผลิตภัณฑ์ บริการ และ/หรือสิ่งอำนวยความสะดวกให้กับท่าน;
              </p>
            </li>
            <li>
              <p>
                (q) เพื่อจัดการและก่อให้เกิดธุรกรรมทางการค้าของท่านกับเรา (เช่น
                การประกวดราคา สัญญาบริการ สัญญาเช่า);
              </p>
            </li>
            <li>
              <p>
                (r) เพื่อประมวลผลการชำระเงินใด ๆ
                ที่เกี่ยวข้องกับธุรกรรมทางการค้าของท่านกับเรา;
              </p>
            </li>
            <li>
              <p>
                (s)
                เพื่อประมวลผลและวิเคราะห์ข้อมูลส่วนบุคคลของท่านทั้งแบบรายบุคคลหรือรวมกับบุคคลอื่น;
              </p>
            </li>
            <li>
              <p>
                (t) เพื่อทำวิจัยหรือแบบสำรวจทางการตลาด การวิเคราะห์การตลาดภายใน
                การทำโปรไฟล์ลูกค้า การวิเคราะห์รูปแบบและการเลือกของลูกค้า
                การวางแผนและการคำนวณสถิติและการวิเคราะห์แนวโน้มที่เกี่ยวข้องกับผลิตภัณฑ์
                และ/หรือ บริการของเรา;
              </p>
            </li>
            <li>
              <p>
                (u)
                เพื่อแบ่งปันข้อมูลส่วนบุคคลของท่านกับผู้ตรวจสอบสำหรับการตรวจสอบและการรายงานภายในของเรา;
              </p>
            </li>
            <li>
              <p>
                (v) เพื่อแบ่งปันข้อมูลส่วนบุคคลของท่านตามสัญญา หรือเอกสารใด ๆ
                ที่ท่านได้ทำกับเราเพื่อวัตถุประสงค์ในการขอคำแนะนำทางกฎหมาย
                และ/หรือทางการเงิน และ/หรือ
                เพื่อวัตถุประสงค์ในการดำเนินการทางกฎหมาย;
              </p>
            </li>
            <li>
              <p>
                (w)
                เพื่อแบ่งปันข้อมูลส่วนบุคคลของท่านกับกิจการร่วมค้า/พันธมิตรทางธุรกิจของเราเพื่อร่วมพัฒนาผลิตภัณฑ์
                และ/หรือบริการ หรือเปิดตัวแคมเปญการตลาด;
              </p>
            </li>
            <li>
              <p>
                (x)
                เพื่อแบ่งปันข้อมูลส่วนบุคคลของท่านกับบริษัทประกันภัยที่จำเป็นเพื่อวัตถุประสงค์ในการสมัครและรับกรมธรรม์ประกันภัย
                หากจำเป็น;
              </p>
            </li>
            <li>
              <p>
                (y)
                เพื่อแบ่งปันข้อมูลส่วนบุคคลของท่านกับสถาบันการเงินที่จำเป็นเพื่อวัตถุประสงค์ในการสมัครและขอวงเงินสินเชื่อ
                หากจำเป็น;
              </p>
            </li>
            <li>
              <p>
                (z) เพื่อวัตถุประสงค์ในการตรวจสอบ
                การบริหารความเสี่ยงและความปลอดภัย;
              </p>
            </li>
            <li>
              <p>
                (aa) เพื่อตรวจจับ ตรวจสอบ และป้องกันการฉ้อโกง
                กิจกรรมที่ต้องห้ามหรือผิดกฎหมาย;
              </p>
            </li>
            <li>
              <p>
                (bb)
                เพื่อให้เราสามารถปฏิบัติตามภาระหน้าที่และบังคับใช้สิทธิของเราภายใต้สัญญาหรือเอกสารใด
                ๆ ที่เราเป็นคู่สัญญา;
              </p>
            </li>
            <li>
              <p>
                (cc) เพื่อโอนหรือมอบหมายสิทธิ
                ผลประโยชน์และภาระหน้าที่ของเราภายใต้สัญญาใด ๆ ที่ทำกับเรา;
              </p>
            </li>
            <li>
              <p>
                (dd)
                เพื่อให้เป็นไปตามกฎหมายหรือข้อบังคับที่เกี่ยวข้องและการเปิดเผยข้อมูลภายใต้ข้อกำหนดของกฎหมาย
                ข้อบังคับ แนวทาง คำสั่งศาล กฎระเบียบ แนวปฏิบัติ
                หนังสือเวียนหรือหลักเกณฑ์ที่บังคับใช้กับเรา;
              </p>
            </li>
            <li>
              <p>
                (ee) เพื่อบังคับใช้หรือปกป้องสิทธิของเราและของท่าน
                และเพื่อปฏิบัติตามภาระหน้าที่ของเราภายใต้กฎหมาย
                การออกกฎหมายและข้อบังคับที่มีผลบังคับใช้;
              </p>
            </li>
            <li>
              <p>
                (ff)
                เพื่อตรวจสอบประวัติและความถูกต้องซึ่งเป็นส่วนหนึ่งของกระบวนการสรรหาและคัดเลือกที่เกี่ยวข้องกับการสมัครงานของท่านเพื่อเข้าทำงานกับเรา
                และ/หรือ
              </p>
            </li>
            <li>
              <p>
                (gg) เพื่อวัตถุประสงค์อื่นในการดำเนินงาน ดำรง
                และจัดการธุรกิจของเราและความสัมพันธ์ของท่านกับเราให้ดีขึ้น
                ซึ่งเราจะแจ้งให้ท่านทราบเมื่อได้รับความยินยอมจากท่านและท่านตกลงและยินยอมให้เราใช้และประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้
                หากท่านไม่ยินยอมให้เราประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์หนึ่งข้อหรือมากกว่า
                กรุณาแจ้งให้เราทราบตามข้อมูลการติดต่อด้านล่าง
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            2.6&nbsp;การเก็บรวบรวมข้อมูลส่วนบุคคลของท่านโดยเรา
            อาจเป็นในกรณีจำเป็นหรือโดยสมัครใจขึ้นอยู่กับวัตถุประสงค์ในการรวบรวมข้อมูลส่วนบุคคลของท่าน
            ในกรณีที่จำเป็นที่ท่านจะต้องให้ข้อมูลส่วนบุคคลของท่านกับเราและท่านได้เพิกเฉย
            หรือเลือกที่จะไม่ให้ข้อมูลดังกล่าวกับเรา
            หรือไม่ยินยอมตามข้างต้นหรือตามนโยบายนี้ เราจะไม่สามารถจัดหาผลิตภัณฑ์
            และ/หรือ บริการ หรือติดต่อกับท่านได้
          </p>
        </li>
      </ul>
      <h2>3. การเปิดเผยข้อมูล</h2>
      <p>
        เราจะไม่ขาย ให้เช่า โอน หรือเปิดเผยข้อมูลส่วนบุคคลใด ๆ
        ของท่านให้กับบุคคลที่สามโดยไม่ได้รับความยินยอมจากท่าน อย่างไรก็ตาม
        เราอาจเปิดเผยข้อมูลส่วนบุคคลของท่านต่อบุคคลที่สามดังต่อไปนี้เพื่อวัตถุประสงค์ข้างต้นหนึ่งข้อหรือมากกว่า:
      </p>
      <ul>
        <li>
          <p>
            (a)
            ระหว่างคาร์ซัมกับบริษัทและบริษัทในเครือที่เกี่ยวข้องของเราทั้งในประเทศไทยหรือต่างประเทศ;
          </p>
        </li>
        <li>
          <p>
            (b) สมาชิกในครอบครัวที่ใกล้ชิดของท่าน และ/หรือ
            บุคคลติดต่อในกรณีฉุกเฉินซึ่งอาจแจ้งให้เราทราบเป็นครั้งคราว;
          </p>
        </li>
        <li><p>(c) ผู้สืบสิทธิแทนเรา;</p></li>
        <li>
          <p>
            (d)
            บุคคลที่อยู่ภายใต้หน้าที่การรักษาความลับซึ่งเรามีส่วนร่วมในการปลดเปลื้องภาระหน้าที่ของเราที่มีต่อท่านซึ่งได้ดำเนินการเพื่อรักษาข้อมูลส่วนบุคคลของท่านให้เป็นความลับ;
          </p>
        </li>
        <li>
          <p>
            (e) ฝ่ายใด ๆ
            ที่เกี่ยวข้องกับการดำเนินการทางกฎหมายหรือกระบวนการทางกฎหมายในอนาคต;
          </p>
        </li>
        <li>
          <p>
            (f) ผู้สอบบัญชี ที่ปรึกษา ทนายความ นักบัญชี
            หรือที่ปรึกษาทางการเงินหรือที่ปรึกษาผู้เชี่ยวชาญอื่น ๆ
            ที่ได้รับการแต่งตั้งเกี่ยวกับธุรกิจของเราบนพื้นฐานที่เป็นความลับอย่างเคร่งครัดซึ่งเราแต่งตั้งขึ้นเพื่อให้บริการแก่เรา;
          </p>
        </li>
        <li>
          <p>
            (g) ฝ่ายใด ๆ ที่ถูกเสนอชื่อหรือแต่งตั้งโดยเรา
            ไม่ว่าเพียงผู้เดียวหรือร่วมกับผู้ให้บริการรายอื่นเพื่อจุดประสงค์ในการสร้างและรักษาฐานข้อมูลทั่วไปซึ่งเรามีผลประโยชน์ตามกฎหมายร่วมกัน;
          </p>
        </li>
        <li>
          <p>
            (h) ศูนย์ข้อมูล และ/หรือ เซิร์ฟเวอร์ที่ตั้งอยู่ใน
            หรือนอกประเทศไทยเพื่อวัตถุประสงค์ในการจัดเก็บข้อมูลหรือวัตถุประสงค์อื่น
            ๆ;
          </p>
        </li>
        <li>
          <p>
            (i)
            ช่องทางการชำระเงินรวมไปถึงแต่ไม่จำกัดแค่เพียงสถาบันการเงินเพื่อวัตถุประสงค์ในการประเมิน
            ตรวจสอบ ทำให้มีผล และอำนวยความสะดวกในการชำระเงินจำนวนใด ๆ
            ที่ถึงกำหนดชำระของท่านในการซื้อผลิตภัณฑ์ และ/หรือบริการของเรา;
          </p>
        </li>
        <li>
          <p>
            (j) หน่วยงานของรัฐ หน่วยงานบังคับใช้กฎหมาย ศาล ศาลพิเศษ
            หน่วยงานกำกับดูแล หน่วยงานกำกับดูแลอุตสาหกรรม กระทรวง และ/หรือ
            หน่วยงานหรือองค์กรตามกฎหมาย สำนักงานหรือเทศบาลใด ๆ ในเขตอำนาจศาล
            หากจำเป็นหรือได้รับอนุญาตให้ทำเช่นนั้นเพื่อให้เป็นไปตามกฎหมาย
            ข้อบังคับ
            คำสั่งหรือคำพิพากษาของศาลหรือศาลพิเศษหรือข้อซักถามจากหน่วยงานที่เกี่ยวข้อง;
          </p>
        </li>
        <li>
          <p>
            (k) กิจการร่วมค้า/พันธมิตรทางธุรกิจของเรา
            ผลิตภัณฑ์ของบุคคลที่สามและ/หรือผู้ให้บริการ ผู้ผลิต ผู้ขาย
            ผู้รับเหมา ผู้ประมวลผลข้อมูลหรือตัวแทนที่จัดหาผลิตภัณฑ์ และ/หรือ
            บริการที่เกี่ยวข้องกับธุรกิจของเรา หรือปลดเปลื้อง
            หรือดำเนินการตามวัตถุประสงค์ข้างต้นหนึ่งข้อหรือมากกว่า
            และวัตถุประสงค์อื่น ๆ ที่จำเป็นในการดำเนินงานและดำรงธุรกิจของเรา
            ซึ่งรวมไปถึงแต่ไม่จำกัดแค่เพียงคอลเซ็นเตอร์ บริษัทโทรคมนาคม
            บริษัทขนส่ง บริษัทเทคโนโลยีสารสนเทศ และศูนย์ข้อมูล
          </p>
        </li>
        <li>
          <p>
            (l) บริษัทประกันภัย
            เพื่อวัตถุประสงค์ในการสมัครและรับกรมธรรม์ประกันภัย หากจำเป็น;
          </p>
        </li>
        <li>
          <p>
            (m) สถาบันการเงินเพื่อวัตถุประสงค์ในการสมัครและรับวงเงินสินเชื่อ
            หากจำเป็น;
          </p>
        </li>
        <li>
          <p>
            (n) สถาบันการเงิน
            ร้านค้าและหน่วยงานบัตรเครดิตที่เกี่ยวข้องกับธุรกรรมทางการค้าของท่านกับเรา;
          </p>
        </li>
        <li>
          <p>
            (o) สาธารณชนทั่วไป เมื่อท่านเป็นผู้ชนะในการแข่งขันโดยการเผยแพร่ชื่อ
            รูปถ่ายและข้อมูลส่วนบุคคลอื่น ๆ ของท่าน
            โดยไม่มีค่าตอบแทนเพื่อวัตถุประสงค์ในการโฆษณาและการประชาสัมพันธ์;
          </p>
        </li>
        <li>
          <p>
            (p) หน่วยงานรายงานเครดิตบุคคลที่สามหรือ
            บริษัทจัดหางานซึ่งเป็นส่วนหนึ่งของการสรรหาและขั้นตอนคัดเลือก
            และ/หรือ อื่น ๆ ที่เกี่ยวข้องกับการสมัครงานของท่านเพื่อทำงานกับเรา;
          </p>
        </li>
        <li>
          <p>
            (q) ในกรณีที่อาจมีการขาย/จำหน่าย ธุรกิจหรือผลประโยชน์ใด ๆ ของเรา
            การควบรวม การเข้าซื้อ การรวมกิจการ การปรับโครงสร้างองค์กร
            การระดมทุนหรือการขายทรัพย์สิน
            ที่เกี่ยวข้องกับเราหรือในกรณีที่มีการเลิกกิจการ (“ธุรกรรม”)
            ข้อมูลส่วนบุคคลของท่านอาจจำเป็นต้องเปิดเผย
            หรือโอนไปยังบุคคลที่สามอันเป็นผลมาจากหรือเกี่ยวข้องกับธุรกรรม
          </p>
        </li>
        <li>
          <p>
            (r)
            ท่านรับทราบว่าการเปิดเผยและการโอนข้อมูลดังกล่าวอาจเกิดขึ้นและอนุญาตให้เราเปิดเผยและโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลที่สามดังกล่าวและที่ปรึกษา/ตัวแทน
            และ/หรือบุคคลใดที่จำเป็นต้องใช้อย่างสมเหตุสมผลเพื่อให้เราดำเนินการและดำรงธุรกิจของเรา
            หรือดำเนินกิจกรรมที่กำหนดไว้ในวัตถุประสงค์
          </p>
        </li>
      </ul>
      <p></p>
      <h2>4. ความถูกต้อง</h2>
      <p>
        เรามุ่งหมายที่จะเก็บรักษาข้อมูลส่วนบุคคลทั้งหมดให้ถูกต้อง ครบถ้วน
        ไม่ทำให้เข้าใจผิด เป็นปัจจุบันและเชื่อถือได้มากที่สุด ฉะนั้น
        ความถูกต้องของข้อมูลส่วนบุคคลของท่านจึงขึ้นอยู่กับข้อมูลที่ท่านให้ไว้เป็นส่วนใหญ่
        ดังนั้นจึงเป็นเงื่อนไขของเราในการจัดหาผลิตภัณฑ์ บริการ
        และ/หรือสิ่งอำนวยความสะดวกให้กับท่านโดยท่านจะต้อง:
      </p>
      <ul>
        <li>
          <p>
            (a)&nbsp;&nbsp;รับรองและยืนยันว่าข้อมูลส่วนบุคคลทั้งหมดของท่านที่ส่งหรือถูกส่งมาให้เรานั้นถูกต้อง
            ไม่ทำให้เข้าใจผิด เป็นปัจจุบันและสมบูรณ์ทุกประการ
            เพื่อวัตถุประสงค์ในการให้ได้มาหรือการใช้ผลิตภัณฑ์ บริการ และ/หรือ
            สิ่งอำนวยความสะดวกที่เกี่ยวข้อง และท่านไม่ได้ปกปิดข้อมูลส่วนบุคคลใด
            ๆ
            ซึ่งอาจเป็นสาระสำคัญและอนุญาตให้เราสันนิษฐานว่าข้อมูลส่วนบุคคลที่ท่านมอบให้มีความถูกต้องและความเป็นปัจจุบันเมื่อประมวลผลข้อมูลส่วนบุคคลดังกล่าว;
            และ
          </p>
        </li>
        <li>
          <p>
            (b)&nbsp;&nbsp;แจ้งให้เราทราบทันทีเมื่อข้อมูลส่วนบุคคลดังกล่าวที่ให้เราไว้ก่อนหน้านี้กลายเป็นข้อมูลที่ไม่ถูกต้อง
            ไม่สมบูรณ์ ทำให้เข้าใจผิด ล้าสมัยหรือเปลี่ยนแปลงไปไม่ว่าจะในทางใด
            โดยติดต่อเราตามข้อมูลการติดต่อด้านล่าง
          </p>
        </li>
      </ul>
      <p></p>
      <h2>5. การเข้าถึง</h2>
      <ul>
        <li>
          <p>
            5.1&nbsp;&nbsp;&nbsp;ภายใต้ข้อยกเว้นที่ระบุไว้ตาม PDPA
            ท่านมีสิทธิ์ที่จะขอเข้าถึงและขอรับสำเนา
            แก้ไขปรับปรุงข้อมูลให้เป็นปัจจุบัน
            หรือแก้ไขข้อมูลส่วนบุคคลของท่านที่เราเก็บไว้
            เราอาจคิดค่าบริการจำนวนเล็กน้อย (ซึ่งเป็นจำนวนเงินตามที่ PDPA
            อนุญาต)
            เพื่อให้ครอบคลุมค่าบริหารจัดการที่เกี่ยวข้องในการดำเนินการตามคำขอเพื่อเข้าถึงข้อมูลส่วนบุคคลของท่าน
          </p>
        </li>
        <li>
          <p>
            5.2&nbsp;&nbsp;&nbsp;ในส่วนของสิทธิของท่านในการเข้าถึง และ/หรือ
            แก้ไขข้อมูลส่วนบุคคลของท่าน เรามีสิทธิที่จะปฏิเสธคำขอในการเข้าถึง
            และ/หรือ แก้ไขข้อมูลส่วนบุคคลของท่าน ด้วยเหตุผลภายใต้กฎหมาย เช่น
            ค่าใช้จ่ายในการให้ท่านเข้าถึงไม่ได้สัดส่วนกับความเสี่ยงต่อความเป็นส่วนตัวของท่าน
            หรือในกรณีที่สิทธิของผู้อื่นอาจถูกละเมิดด้วย เป็นต้น
          </p>
        </li>
        <li>
          <p>
            5.3&nbsp;&nbsp;&nbsp;ท่านมีสิทธิที่จะขอให้เราจำกัดการประมวลผลและใช้ข้อมูลส่วนบุคคลของท่านได้ตลอดเวลา
            (ตัวอย่างเช่น ขอให้เราหยุดส่งสื่อการตลาดและการส่งเสริมการขายใด ๆ
            ให้กับท่าน หรือติดต่อท่านเพื่อวัตถุประสงค์ทางการตลาด)
          </p>
        </li>
        <li>
          <p>
            5.4&nbsp;&nbsp;&nbsp;นอกจากนี้
            ท่านยังมีสิทธิแจ้งให้เราทราบเป็นลายลักษณ์อักษรเพื่อเพิกถอนความยินยอมของท่าน
            (ทั้งหมดหรือบางส่วน) ที่มอบให้เราก่อนหน้านี้ภายใต้กฎหมายที่บังคับใช้
            ข้อจำกัด
            เงื่อนไขตามสัญญาและระยะเวลาที่เหมาะสมในการเพิกถอนความยินยอมที่จะมีผล
            อย่างไรก็ตามการเพิกถอนความยินยอมของท่านอาจส่งผลทางกฎหมายที่เกิดจากการเพิกถอนดังกล่าว
            ขึ้นอยู่กับขอบเขตของการเพิกถอนความยินยอมที่ให้เราดำเนินการกับข้อมูลส่วนบุคคลของท่าน
            ซึ่งอาจหมายความว่าเราจะไม่สามารถดำเนินความสัมพันธ์ที่เรามีอยู่
            และ/หรือสัญญาที่ท่านมีกับเราจะต้องถูกยกเลิก
          </p>
        </li>
      </ul>
      <h2>6. การเก็บรักษา</h2>
      <p>
        ข้อมูลส่วนบุคคลใด ๆ
        ของท่านที่ให้กับเราจะถูกเก็บรักษาไว้ตราบเท่าที่วัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลยังคงดำเนินต่อไป
        ข้อมูลส่วนบุคคลของท่านจะถูกทำลายจากบันทึกและระบบของเราตามนโยบายการเก็บรักษาของเรา
        เมื่อข้อมูลส่วนบุคคลของท่านไม่จำเป็นสำหรับวัตถุประสงค์ดังกล่าวอีกต่อไป
        เว้นแต่จะต้องมีการเก็บรักษาเพิ่มเติมเพื่อให้เป็นไปตามระยะเวลาการเก็บรักษาที่นานขึ้นเพื่อให้เป็นไปตามข้อกำหนดในการปฏิบัติงาน
        กฎหมาย ระเบียบ ภาษีหรือการบัญชีของเรา
      </p>
      <h2>7. ความปลอดภัย</h2>
      <ul>
        <li>
          <p>
            7.1&nbsp;&nbsp;&nbsp;เรามุ่งมั่นที่จะสร้างความมั่นใจว่าข้อมูลส่วนบุคคลของท่านจะถูกจัดเก็บอย่างปลอดภัย
            เพื่อป้องกันการเข้าถึง การเปิดเผยหรือความเสี่ยงอื่น ๆ
            ที่คล้ายกันโดยไม่ได้รับอนุญาต
            เราพยายามที่จะใช้มาตรการความปลอดภัยทางเทคนิค ทางกายภาพ
            ทางอิเล็กทรอนิกส์และขั้นตอนมาตรการความปลอดภัยที่เหมาะสมตามกฎหมาย
            ข้อบังคับและมาตรฐานอุตสาหกรรม
            เพื่อคุ้มครองและป้องกันการประมวลผลข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับอนุญาตหรือผิดกฎหมาย
            และจากการทำลายหรือความสูญหายโดยบังเอิญ ความเสียหาย
            การแก้ไขเปลี่ยนแปลง
            การเปิดเผยหรือการเข้าถึงข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับอนุญาต
          </p>
        </li>
        <li>
          <p>
            7.2&nbsp;&nbsp;&nbsp;เราจะปรับปรุงมาตรการความปลอดภัยให้เป็นปัจจุบันตามสมควรเป็นครั้งคราวและตรวจสอบให้แน่ใจว่าบุคคลที่สามที่ได้รับอนุญาตได้ใช้ข้อมูลส่วนบุคคลของท่านเป็นไปตามวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้เท่านั้น
          </p>
        </li>
        <li>
          <p>
            7.3&nbsp;&nbsp;&nbsp;อินเทอร์เน็ตไม่ใช่สื่อที่ปลอดภัย
            อย่างไรก็ตามเราจะจัดวางขั้นตอนความปลอดภัยต่าง ๆ
            เกี่ยวกับไซต์และการสื่อสารทางอิเล็กทรอนิกส์ของท่านกับเรา โดยพนักงาน
            กิจการร่วมค้า/พันธมิตรทางธุรกิจ ตัวแทน ผู้รับเหมา ผู้ขาย ผู้ผลิต
            ผู้ประมวลผลข้อมูล ผลิตภัณฑ์ของบุคคลที่สามและ/หรือผู้ให้บริการทั้งหมด
            ที่สามารถเข้าถึงและเกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคลของท่าน
            จะมีภาระหน้าที่ต้องปฏิบัติตามการรักษาความลับของข้อมูลส่วนบุคคลของท่าน
          </p>
        </li>
        <li>
          <p>
            7.4&nbsp;&nbsp;&nbsp;โปรดรับทราบว่าการสื่อสารผ่านอินเทอร์เน็ต เช่น
            อีเมล/เว็บเมลนั้น ไม่ปลอดภัย เว้นแต่จะได้รับการเข้ารหัส
            โดยการสื่อสารของท่านอาจถูกส่งผ่านไปยังหลายประเทศก่อนที่จะถูกส่งออกไป
            - นีคือลักษณะของ World Wide Web / Internet
          </p>
        </li>
        <li>
          <p>
            7.5&nbsp;&nbsp;&nbsp;เราไม่สามารถและจะไม่รับผิดชอบต่อการเข้าถึงโดยไม่ได้รับอนุญาต
            หรือการขัดขวาง
            หรือการสูญเสียข้อมูลส่วนบุคคลที่อยู่นอกเหนือการควบคุมที่เหมาะสมของเรา
          </p>
        </li>
      </ul>
      <h2>8. การโอนข้อมูลออกนอกประเทศไทย</h2>
      <p>
        สถานที่จัดเก็บเทคโนโลยีสารสนเทศและเซิร์ฟเวอร์ของเราอาจตั้งอยู่ในเขตอำนาจศาลอื่นนอกประเทศไทย
        ซึ่งอาจรวมถึงแต่ไม่จำกัดเพียงกรณีที่ข้อมูลส่วนบุคคลของท่านอาจถูกเก็บไว้บนเซิร์ฟเวอร์ที่อยู่นอกประเทศไทย
        นอกจากนี้
        ข้อมูลส่วนบุคคลของท่านอาจถูกเปิดเผยหรือโอนไปยังหน่วยงานที่อยู่นอกประเทศไทย
        หรือที่ที่ท่านเข้าถึงไซต์จากประเทศอื่นนอกประเทศไทย
        กรุณารับทราบว่าหน่วยงานต่างประเทศเหล่านี้อาจจัดตั้งขึ้นในประเทศอื่นที่อาจไม่มีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลเท่ากับที่มีในประเทศไทยภายใต้กฎหมายของประเทศไทย
        ท่านยินยอมโดยชัดแจ้งให้เราถ่ายโอนข้อมูลส่วนบุคคลของท่านออกนอกประเทศไทยเพื่อวัตถุประสงค์ดังกล่าว
        เราจะพยายามตรวจสอบให้แน่ใจว่ามีการดำเนินการตามขั้นตอนที่เหมาะสมในการจัดการให้บุคคลที่สามดังกล่าวทั้งหมดนอกประเทศไทยจะไม่ใช้ข้อมูลส่วนบุคคลของท่านนอกเหนือไปจากวัตถุประสงค์และเพื่อปกป้องการรักษาความลับและความเป็นส่วนตัวของข้อมูลส่วนบุคคลของท่านอย่างเพียงพอ
      </p>
      <h2>9. การเชื่อมต่อกับภายนอก</h2>
      <ul>
        <li>
          <p>
            9.1&nbsp;&nbsp;&nbsp;หากส่วนใดส่วนหนึ่งของไซต์เชื่อมโยงท่านไปยังเว็บไซต์อื่น
            ๆ
            เว็บไซต์เหล่านั้นจะไม่ได้ดำเนินการภายใต้นโยบายนี้และเราไม่ยอมรับต่อความรับผิดชอบหรือความรับผิดใด
            ๆ ที่เกิดขึ้นจากเว็บไซต์เหล่านั้น
          </p>
        </li>
        <li>
          <p>
            9.2&nbsp;&nbsp;&nbsp;ในทำนองเดียวกัน หากท่านสมัครแอปพลิเคชั่น
            เนื้อหา
            หรือผลิตภัณฑ์จากพันธมิตรเชิงกลยุทธ์ของเราและในภายหลังท่านให้ข้อมูลส่วนบุคคลของท่านโดยตรงกับบุคคลที่สาม
            ข้อมูลส่วนบุคคลนั้นจะอยู่ภายใต้นโยบายความเป็นส่วนตัว/
            นโยบายการคุ้มครองข้อมูลส่วนบุคคลของบุคคลที่สามนั้น
            (หากบุคคลที่สามนั้นมีนโยบายดังกล่าว) และไม่ใช่ตามนโยบายนี้
          </p>
        </li>
        <li>
          <p>
            9.3&nbsp;&nbsp;&nbsp;เราแนะนำให้ท่านอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัว
            คำแถลง/นโยบายการคุ้มครองข้อมูลส่วนบุคคล ที่โพสต์บนเว็บไซต์อื่น
            เพื่อทำความเข้าใจขั้นตอนการเก็บรวบรวม การประมวลผล
            การใช้และการเปิดเผยข้อมูลส่วนบุคคล
            ก่อนการส่งข้อมูลส่วนบุคคลของท่านไปยังเว็บไซต์เหล่านั้น
          </p>
        </li>
      </ul>
      <h2>10. คุกกี้</h2>
      <ul>
        <li>
          <p>
            10.1&nbsp;&nbsp;&nbsp;เราใช้เทคโนโลยีมาตรฐานอุตสาหกรรมที่เรียกว่า
            “คุกกี้” ซึ่งคุกกี้เป็นข้อมูลหน่วยเล็ก ๆ ที่เก็บไว้ในฮาร์ดไดรฟ์
            (Hard drive)
            ของคอมพิวเตอร์หรืออุปกรณ์ของท่านมีวัตถุประสงค์ในการเก็บบันทึกและเราใช้เพื่อติดตามการเยี่ยมชมไซต์ของท่าน
            โดยคุกกี้อาจถูกใช้เพื่อบันทึกการตั้งค่าเพื่อความสะดวกของท่านเมื่อใช้งานไซต์
            เครือข่ายโฆษณาของบุคคลที่สามอาจส่งคุกกี้แยกต่างหากไปยังฮาร์ดไดรฟ์ของท่านเมื่อมีการให้บริการโฆษณา
          </p>
        </li>
        <li>
          <p>
            10.2&nbsp;&nbsp;&nbsp;ข้อมูลเกี่ยวกับพฤติกรรมการใช้งานเว็บไซต์
            (Clickstream) ที่ไม่ระบุตัวตนที่เราเก็บรวบรวมผ่านคุกกี้
            อาจรวมถึงที่อยู่อินเทอร์เน็ตโปรโตคอล (IP Address)
            ซอฟต์แวร์เว็บเบราว์เซอร์ วันที่และเวลาในการเยี่ยมชมไซต์ของท่าน
            และไม่ว่าคำขอของท่าน (รวมถึงคำขอค้นหาและการคลิ๊กลิงก์ไปยังส่วนต่าง ๆ
            ของไซต์) จะบรรลุผลหรือไม่
            โดยข้อมูลดังกล่าวทั้งหมดที่เก็บรวบรวมผ่านคุกกี้นั้นไม่ใช่ข้อมูลส่วนบุคคลและไม่สามารถระบุตัวตนของท่านได้จากข้อมูลนี้
            ข้อมูลดังกล่าวใช้สำหรับการจัดการและสร้างประสบการณ์ผู้ใช้ที่ดีขึ้นและเพื่อระบุจุดสำหรับการปรับปรุงบนไซต์
          </p>
        </li>
        <li>
          <p>
            10.3&nbsp;&nbsp;&nbsp;ปัจจุบันการใช้คุกกี้เป็นมาตรฐานอุตสาหกรรมประเภทหนึ่ง
            และท่านจะพบคุกกี้เหล่านี้บนเว็บไซต์หลัก ๆ
            โดยเบราว์เซอร์ส่วนใหญ่ถูกตั้งค่าให้ยอมรับคุกกี้ในตอนต้น
            ซึ่งท่านสามารถตั้งค่าเบราว์เซอร์ใหม่ได้หากต้องการ
            โดยให้เบราว์เซอร์แจ้งให้ทราบเมื่อท่านได้รับคุกกี้หรือปฏิเสธที่จะยอมรับคุกกี้
            ท่านควรทราบว่าคุณสมบัติบางอย่างบนไซต์จะทำงานได้ไม่สมบูรณ์
            หากท่านตั้งค่าเบราว์เซอร์ของท่านให้ไม่ยอมรับคุกกี้
          </p>
        </li>
      </ul>
      <h2>11. การติดต่อ</h2>
      <p>
        ในกรณีที่ท่านมีคำถามเกี่ยวกับนโยบายนี้ มีข้อสงสัยเพิ่มเติม
        หรือต้องการร้องเรียน การเข้าถึงข้อมูล
        การขอแก้ไขเกี่ยวกับข้อมูลส่วนบุคคลของท่าน
        สามารถติดต่อเจ้าหน้าที่ที่กำกับดูแลการปฏิบัติงานของเราที่ &lt;<a
          href="mailto:info@carsome.co.th"
          target="_blank"
          >info@carsome.co.th</a
        >&gt;
      </p>
      <h2>12. ภาษา</h2>
      <p>
        ในกรณีที่มีข้อขัดแย้งระหว่างนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับภาษาอังกฤษกับนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับภาษาไทย
        ให้ข้อกำหนดนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับภาษาไทยมีผลเหนือกว่า
      </p>
      <p></p>
      <p><b>วันที่: 15 มิถุนายน 2564</b></p>
      <p></p>
      <h2 style="padding-top:40px">PERSONAL DATA PROTECTION POLICY</h2>
      <h2>1. INTRODUCTION</h2>
      <ul>
        <li>
          <p>
            1.&nbsp;&nbsp;&nbsp;This Policy applies to personal information
            about individuals (including but not limited to customers, vendors,
            distributors, suppliers, service providers, joint venture/business
            partners, job applicants, employees) held by us. We will only
            process your Personal Data in accordance with the Personal Data
            Protection Act B.E. 2562 (2019), the applicable regulations,
            guidelines, orders made under the Act 709 and any statutory
            amendments or re-enactments made of the Personal Data Protection Act
            B.E. 2562 (2019) from time to time (collectively referred to as the
            “PDPA”) as well as this Policy.
          </p>
        </li>
        <li>
          <p>
            2.&nbsp;&nbsp;&nbsp;By providing your Personal Data to us and/or
            continuing to access and use our website (“Site”), you declare that
            you have read and understood this Policy and agree to us processing
            your Personal Data in accordance with the manner as set out in this
            Policy.
          </p>
        </li>
        <li>
          <p>
            3.&nbsp;&nbsp;&nbsp;We reserve the right to modify, update and/or
            amend this Policy from time to time. We will notify you of any
            amendments via announcements on the Site or other appropriate means.
            Please check the Site from time to time to see if there are
            amendments to this Policy.
          </p>
        </li>
        <li>
          <p>
            4.&nbsp;&nbsp;&nbsp;In the event you do not agree to this Policy or
            any amendments to this Policy, we may not be able to render all
            services to you and you may be required to terminate your relevant
            agreement with us and/or stop accessing or using the Site.
          </p>
        </li>
      </ul>
      <h2>2. COLLECTION</h2>
      <ul>
        <li>
          <p>
            2.1.&nbsp;&nbsp;&nbsp;The term “Personal Data” means any information
            in our possession or control that relates directly or indirectly to
            an individual to the extent that the individual can be identified or
            are identifiable from that and other information in our possession,
            such as name, address, telephone number, Identification/Passport
            number, date of birth, photograph, email address, household
            information, etc. as well as Sensitive Personal Data as defined
            under the PDPA, which includes but is not limited to, information
            pertaining to the physical or mental health or condition of a data
            subject and religious beliefs.
          </p>
        </li>
        <li>
          <p>
            2.2.&nbsp;&nbsp;&nbsp;The types of Personal Data collected depend on
            the purpose of collection. We may process your Personal Data by way
            of collecting, recording, holding, storing, using and/or disclosing
            it.
          </p>
        </li>
        <li>
          <p>
            2.3.&nbsp;&nbsp;&nbsp;Your Personal Data may be collected from you
            during your course of dealings with us in any way or manner
            including pursuant to any transactions and/or communications made
            from/with us. We may also collect your Personal Data from a variety
            of sources, including without limitation, at any events, seminars,
            road shows, customer satisfaction surveys organised and/or sponsored
            by us, as well as from publicly available sources.
          </p>
        </li>
        <li>
          <p>
            2.4.&nbsp;&nbsp;&nbsp;In addition, we may also receive, store and
            process your Personal Data which are provided or made available by
            any third parties, credit reference bodies, regulatory and law
            enforcement authorities, for reasons including delivery of our
            products and/or services, performance of conditions of agreements
            and/or to comply with our legal and regulatory obligations.
          </p>
        </li>
        <li>
          <p>
            2.5.&nbsp;&nbsp;&nbsp;The Personal Data as provided/furnished by you
            to us or collected by us from you or through such other sources as
            may be necessary for the fulfilment of the purposes at the time it
            was sought or collected, may be processed for the following purposes
            (collectively referred to as the “Purposes”):
          </p>
          <ul>
            <li><p>(a)to communicate with you;</p></li>
            <li><p>(b)to maintain and improve customer relationship;</p></li>
            <li>
              <p>
                (c)to assess, process and provide products, services and/or
                facilities to you;
              </p>
            </li>
            <li>
              <p>
                (d)to administer and process any payments related to products,
                services and/or facilities requested by you;
              </p>
            </li>
            <li><p>(e)to establish your identity and background;</p></li>
            <li>
              <p>
                (f)to respond to your enquiries or complaints and resolve any
                issues and/or disputes which may arise in connection with any
                dealings with us;
              </p>
            </li>
            <li>
              <p>
                (g)to provide you with information and/or updates on our
                products, services, upcoming promotions offered by us and/or
                events organised by us and selected third parties which may be
                of interest to you from time to time;
              </p>
            </li>
            <li>
              <p>
                (h)for direct marketing purposes via SMS, phone call, email,
                fax, mail, social media and/or any other appropriate
                communication channels;
              </p>
            </li>
            <li>
              <p>
                (i)to facilitate your participation in, and our administration
                of, any events including contests, promotions or campaigns;
              </p>
            </li>
            <li>
              <p>(j)to award points in a loyalty or rewards programme;</p>
            </li>
            <li><p>(k)to maintain and update internal record keeping;</p></li>
            <li><p>(l)for internal administrative purposes;</p></li>
            <li>
              <p>
                (m)to send you seasonal greetings messages from time to time;
              </p>
            </li>
            <li>
              <p>
                (n)to send you the invitation to join our events, promotions and
                product launch events;
              </p>
            </li>
            <li>
              <p>
                (o)to monitor, review and improve our events, promotions,
                products and/or services;
              </p>
            </li>
            <li>
              <p>
                (p)to conduct credit reference checks and establish your
                creditworthiness, where necessary, in providing you with the
                products, services and/or facilities;
              </p>
            </li>
            <li>
              <p>
                (q)to administer and give effect to your commercial transactions
                with us (such as a tender award, contract for service, tenancy
                agreement);
              </p>
            </li>
            <li>
              <p>
                (r)to process any payments related to your commercial
                transactions with us;
              </p>
            </li>
            <li>
              <p>
                (s)to process and analyse your Personal Data either individually
                or collectively with other individuals;
              </p>
            </li>
            <li>
              <p>
                (t)to conduct market research or surveys, internal marketing
                analysis, customer profiling activities, analysis of customer
                patterns and choices, planning and statistical and trend
                analysis in relation to our products and/or services;
              </p>
            </li>
            <li>
              <p>
                (u)to share any of your Personal Data with the auditor for our
                internal audit and reporting purposes;
              </p>
            </li>
            <li>
              <p>
                (v)to share any of your Personal Data pursuant to any agreement
                or document which you have duly entered with us for purposes of
                seeking legal and/or financial advice and/or for purposes of
                commencing legal action;
              </p>
            </li>
            <li>
              <p>
                (w)to share any of your Personal Data with our joint
                venture/business partners to jointly develop products and/or
                services or launch marketing campaigns;
              </p>
            </li>
            <li>
              <p>
                (x)to share any of your Personal Data with insurance companies
                necessary for the purpose of applying and obtaining insurance
                policy(ies), if necessary;
              </p>
            </li>
            <li>
              <p>
                (y)to share any of your Personal Data with financial
                institutions necessary for the purpose of applying and obtaining
                credit facility(ies), if necessary;
              </p>
            </li>
            <li><p>(z)for audit, risk management and security purposes;</p></li>
            <li>
              <p>
                (aa)for detecting, investigating and preventing fraudulent,
                prohibited or illegal activities;
              </p>
            </li>
            <li>
              <p>
                (bb)for enabling us to perform our obligations and enforce our
                rights under any agreements or documents that we are a party to;
              </p>
            </li>
            <li>
              <p>
                (cc)to transfer or assign our rights, interests and obligations
                under any agreements entered into with us;
              </p>
            </li>
            <li>
              <p>
                (dd)for meeting any applicable legal or regulatory requirements
                and making disclosure under the requirements of any applicable
                law, regulation, direction, court order, by-law, guideline,
                circular or code applicable to us;
              </p>
            </li>
            <li>
              <p>
                (ee)to enforce or defend our rights and your rights under, and
                to comply with, our obligations under the applicable laws,
                legislation and regulations;
              </p>
            </li>
            <li>
              <p>
                (ff)to carry out verification and background checks as part of
                any recruitment and selection process in connection with your
                application for employment with us; and/or
              </p>
            </li>
            <li>
              <p>
                (gg)for other purposes required to operate, maintain and better
                manage our business and your relationship with us, which we
                notify you of at the time of obtaining your consent; and you
                agree and consent to us using and processing your Personal Data
                for the Purposes in the manner as identified in this Policy. If
                you do not consent to us processing your Personal Data for one
                or more of the Purposes, please notify us at the contact details
                below.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            2.6.&nbsp;&nbsp;&nbsp;The collection of your Personal Data by us may
            be mandatory or voluntary in nature depending on the Purposes for
            which your Personal Data is collected. Where it is obligatory for
            you to provide us with your Personal Data, and you fail or choose
            not to provide us with such data, or do not consent to the above or
            this Policy, we will not be able to provide products and/or services
            or otherwise deal with you.
          </p>
        </li>
      </ul>
      <h2>3. DISCLOSURE</h2>
      <p>
        We will not sell, rent, transfer or disclose any of your Personal Data
        to any third party without your consent. However, we may disclose your
        Personal Data to the following third parties, for one or more of the
        above Purposes:
      </p>
      <ul>
        <li>
          <p>
            (a)Between Carsome and our related corporations and affiliates
            either in Thailand or overseas;
          </p>
        </li>
        <li>
          <p>
            (b)your immediate family members and/or emergency contact person as
            may be notified to us from time to time;
          </p>
        </li>
        <li><p>(c)successors in title to us;</p></li>
        <li>
          <p>
            (d)any person under a duty of confidentiality which we have engaged
            to discharge our obligations to you, to whom has undertaken to keep
            your Personal Data confidential;
          </p>
        </li>
        <li>
          <p>
            (e)any party in relation to legal proceedings or prospective legal
            proceedings;
          </p>
        </li>
        <li>
          <p>
            (f)our auditors, consultants, lawyers, accountants or other
            financial or professional advisers appointed in connection with our
            business on a strictly confidential basis, appointed by us to
            provide services to us;
          </p>
        </li>
        <li>
          <p>
            (g)any party nominated or appointed by us either solely or jointly
            with other service providers, for purpose of establishing and
            maintaining a common database where we have a legitimate common
            interest;
          </p>
        </li>
        <li>
          <p>
            (h)data centres and/or servers located within or outside Thailand
            for data storage purposes or otherwise;
          </p>
        </li>
        <li>
          <p>
            (i)payment channels including but not limited to financial
            institutions for purpose of assessing, verifying, effectuating and
            facilitating payment of any amount due to us in connection with your
            purchase of our products and/or services;
          </p>
        </li>
        <li>
          <p>
            (j)government agencies, law enforcement agencies, courts, tribunals,
            regulatory bodies, industry regulators, ministries, and/or statutory
            agencies or bodies, offices or municipality in any jurisdiction, if
            required or authorised to do so, to satisfy any applicable law,
            regulation, order or judgment of a court or tribunal or queries from
            the relevant authorities;
          </p>
        </li>
        <li>
          <p>
            (k)our joint venture/business partners, third-party product and/or
            service providers, suppliers, vendors, contractors, data processors
            or agents, that provide related products and/or services in
            connection with our business, or discharge or perform one or more of
            the above Purposes and other purposes required to operate and
            maintain our business, including but not limited to call centres,
            telecommunication companies, logistics companies, information
            technology companies and data centres;
          </p>
        </li>
        <li>
          <p>
            (l)insurance companies for the purpose of applying and obtaining
            insurance policy(ies), if necessary;
          </p>
        </li>
        <li>
          <p>
            (m)financial institutions for the purpose of applying and obtaining
            credit facility(ies), if necessary;
          </p>
        </li>
        <li>
          <p>
            (n)financial institutions, merchants and credit card organisations
            in connection with your commercial transactions with us;
          </p>
        </li>
        <li>
          <p>
            (o)the general public when you become a winner in a contest by
            publishing your name, photographs and other Personal Data without
            compensation for advertising and publicity purposes;
          </p>
        </li>
        <li>
          <p>
            (p)to third-party credit reporting or employment agencies as part of
            the recruitment and selection process and/or otherwise in connection
            with your application for employment with us;
          </p>
        </li>
        <li>
          <p>
            (q)in the event of a potential, proposed or actual sale/disposal of
            any of our business or interest, merger, acquisition, consolidation,
            re-organisation, funding exercise or asset sale relating to us, or
            in the event of winding-up (“Transaction”), your Personal Data may
            be required to be disclosed or transferred to a third party as a
            result of or in connection with, the Transactions.
          </p>
        </li>
        <li>
          <p>
            (r)You hereby acknowledge that such disclosure and transfer may
            occur and permit us to disclose and transfer your Personal Data to
            such third party and its advisors/representatives and/or any other
            person reasonably requiring the same in order for us to operate and
            maintain our business or carry out the activities set out in the
            Purposes.
          </p>
        </li>
      </ul>
      <p></p>
      <h2>4. ACCURACY</h2>
      <p>
        We aim to keep all Personal Data as accurate, complete, not misleading,
        up-to-date and reliable as possible. Therefore, the accuracy of your
        Personal Data depends to a large extent on the information you provide.
        As such, it is a condition of us providing the products, services and/or
        facilities to you that you:
      </p>
      <ul>
        <li>
          <p>
            (a)warrant and declare that all your Personal Data submitted or to
            be submitted to us are accurate, not misleading, updated and
            complete in all respects for purposes of acquiring or using the
            relevant products, services and/or facilities, and you have not
            withheld any Personal Data which may be material in any respect and
            that we are authorised to assume the accuracy and up-to-dateness of
            the Personal Data given by you when processing such Personal Data);
            and
          </p>
        </li>
        <li>
          <p>
            (b)promptly update us as and when such Personal Data provided
            earlier to us becomes inaccurate, incomplete, misleading, outdated
            or changes in any way whatsoever by contacting us at the contact
            details below.
          </p>
        </li>
      </ul>
      <p></p>
      <h2>5. ACCESS</h2>
      <ul>
        <li>
          <p>
            5.1.&nbsp;&nbsp;&nbsp;Subject to the exceptions provided under the
            PDPA, you have the right to request for access to, for a copy of, to
            update or correct, your Personal Data held by us. We may charge a
            small fee (such amount as permitted by the PDPA) to cover the
            administration costs involved in processing your request to access
            your Personal Data.
          </p>
        </li>
        <li>
          <p>
            5.2.&nbsp;&nbsp;&nbsp;In respect of your right to access and/or
            correct your Personal Data, we have the right to refuse your request
            to access and/or correct your Personal Data for the reasons
            permitted under the law, such as where the expense of providing
            access to you is disproportionate to the risks to your privacy, or
            where the rights of others may also be violated, amongst other
            reasons.
          </p>
        </li>
        <li>
          <p>
            5.3.&nbsp;&nbsp;&nbsp;You have the right at any time to request us
            to limit the processing and use of your Personal Data (for example,
            requesting us to stop sending you any marketing and promotional
            materials or contacting you for marketing purposes).
          </p>
        </li>
        <li>
          <p>
            5.4.&nbsp;&nbsp;&nbsp;In addition, you also have the right, by
            notice in writing, to inform us on your withdrawal (in full or in
            part) of your consent given previously to us subject to any
            applicable legal restrictions, contractual conditions and a
            reasonable duration of time for the withdrawal of consent to be
            affected. However, your withdrawal of consent could result in
            certain legal consequences arising from such withdrawal. In this
            regard, depending on the extent of your withdrawal of consent for us
            to process your Personal Data, it may mean that we will not be able
            to continue with your existing relationship with us and/or the
            contract that you have with us will have to be terminated.
          </p>
        </li>
      </ul>
      <h2>6. RETENTION</h2>
      <p>
        Any of your Personal Data provided to us is retained for as long as the
        Purposes for which the Personal Data was collected continues. Your
        Personal Data will be destroyed from our records and system in
        accordance with our retention policy in the event your Personal Data is
        no longer required for the said purposes unless its further retention is
        required to satisfy a longer retention period to meet our operational,
        legal, regulatory, tax or accounting requirements.
      </p>
      <h2>7. SECURITY</h2>
      <ul>
        <li>
          <p>
            7.1.&nbsp;&nbsp;&nbsp;We are committed to ensuring that your
            Personal Data is stored securely. In order to prevent unauthorised
            access, disclosure or other similar risks, we endeavour, where
            practicable, to implement appropriate technical, physical,
            electronic and procedural security measures in accordance with the
            applicable laws and regulations and industry standard to safeguard
            against and prevent the unauthorised or unlawful processing of your
            Personal Data, and the destruction of, or accidental loss, damage
            to, alteration of, unauthorised disclosure of or access to your
            Personal Data.
          </p>
        </li>
        <li>
          <p>
            7.2.&nbsp;&nbsp;&nbsp;We will make reasonable updates to its
            security measures from time to time and ensure the authorised third
            parties only use your Personal Data for the Purposes set out in this
            Policy.
          </p>
        </li>
        <li>
          <p>
            7.3.&nbsp;&nbsp;&nbsp;The Internet is not a secure medium. However,
            we will put in place various security procedures with regard to the
            Site and your electronic communications with us. All our employees,
            joint venture/business partners, agents, contractors, vendors,
            suppliers, data processors, third-party product and/or service
            providers, who have access to, and are associated with the
            processing of your Personal Data, are obliged to respect the
            confidentiality of your Personal Data.
          </p>
        </li>
        <li>
          <p>
            7.4.&nbsp;&nbsp;&nbsp;Please be aware that communications over the
            Internet, such as emails/webmails are not secure unless they have
            been encrypted. Your communications may be routed through a number
            of countries before being delivered – this is the nature of the
            World Wide Web/Internet.
          </p>
        </li>
        <li>
          <p>
            7.5.&nbsp;&nbsp;&nbsp;We cannot and do not accept responsibility for
            any unauthorised access or interception or loss of Personal Data
            that is beyond our reasonable control.
          </p>
        </li>
      </ul>
      <h2>8. TRANSFER OUTSIDE OF THAILAND</h2>
      <p>
        Our information technology storage facilities and servers may be located
        in other jurisdictions outside of Thailand. This may include, but not
        limited to, instances where your Personal Data may be stored on servers
        located outside Thailand. In addition, your Personal Data may be
        disclosed or transferred to entities located outside Thailand or where
        you access the Site from countries outside Thailand. Please note that
        these foreign entities may be established in countries that might not
        offer a level of data protection that is equivalent to that offered in
        Thailand under the laws of Thailand. You hereby expressly consent to us
        transferring your Personal Data outside of Thailand for such purposes.
        We shall endeavour to ensure that reasonable steps are taken to procure
        that all such third parties outside of Thailand shall not use your
        Personal Data other than for that part of the Purposes and to adequately
        protect the confidentiality and privacy of your Personal Data.
      </p>
      <h2>9. EXTERNAL LINKS</h2>
      <ul>
        <li>
          <p>
            9.1.&nbsp;&nbsp;&nbsp;If any part of the Site links you to other
            websites, those websites do not operate under this Policy and we do
            not accept any responsibility or liability arising from those
            websites.
          </p>
        </li>
        <li>
          <p>
            9.2.&nbsp;&nbsp;&nbsp;Likewise, if you subscribe to an application,
            content or a product from our strategic partner and you subsequently
            provide your Personal Data directly to that third party, that
            Personal Data will be subject to that third party’s privacy/personal
            data protection policy (if they have such a policy) and not to this
            Policy.
          </p>
        </li>
        <li>
          <p>
            9.3.&nbsp;&nbsp;&nbsp;We recommend you to read and understand the
            privacy/personal data protection statement/policy posted on those
            other websites in order to understand their procedures for
            collecting, processing, using and disclosing personal data and
            before submitting your Personal Data to those websites.
          </p>
        </li>
      </ul>
      <h2>10. COOKIES</h2>
      <ul>
        <li>
          <p>
            10.1.&nbsp;&nbsp;&nbsp;We employ an industry standard technology
            called “cookies”. The cookie is a small piece of information stored
            on the hard drive of your computer or device for record-keeping
            purposes and is used by us to track your visits to the Site. Cookies
            may be used to save your preferences for your ease and convenience
            when using the Site. Third party advertising networks may issue
            their separate cookies to your hard drive when serving
            advertisements.
          </p>
        </li>
        <li>
          <p>
            10.2.&nbsp;&nbsp;&nbsp;The type of anonymous clickstream data
            collected by us through the cookies may include your Internet
            Protocol address, web browser software, date and time of visit to
            the Site, and whether your requests (including search requests and
            clicking on links to parts of the Site) were met with success. All
            such information collected through cookies is not Personal Data and
            you cannot be identified from this information. Such information is
            only used for the purpose of managing and creating a better user
            experience and to identify areas for improvement on the Site.
          </p>
        </li>
        <li>
          <p>
            10.3.&nbsp;&nbsp;&nbsp;The use of cookies is now an industry
            standard, and you will find them used on most major websites. Most
            browsers are initially set up to accept cookies. If you prefer, you
            can reset your browser either to notify you when you have received a
            cookie or to refuse to accept cookies. You should understand that
            certain features on the Site will not function properly if you set
            your browser to not accept cookies.
          </p>
        </li>
      </ul>
      <h2>11. CONTACT</h2>
      <p>
        In the event you have any questions about this Policy, have any further
        queries, or would like to make a complaint, data access, correction
        request in respect of your Personal Data, you may contact our Compliance
        Officer at &lt;<a href="mailto:info@carsome.co.th" target="_blank"
          >info@carsome.co.th</a
        >&gt;.
      </p>
      <h2>12. LANGUAGE</h2>
      <p>
        In the event of any conflict between the English language Personal Data
        Protection Policy and its corresponding Thai Personal Data Protection
        Policy, the terms in the Thai language Personal Data Protection Policy
        shall prevail.
      </p>
      <p></p>
      <p>Dated: June 15, 2021</p>
    </div>
  </div>
</template>


<style scoped>
.container {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
  color: #000;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
}


h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

ul {
  padding-left: 12px;
}
</style>
